<div
    class="section-header"
    [attr.aria-labelledby]="titleId"
    [attr.aria-describedby]="description ? descriptionId : null"
>
    <div class="section-header-text">
        <h3 class="section-header-title" [id]="titleId">{{ title }}</h3>
        @if (description; as desc) {
            <p class="section-header-description" [id]="descriptionId">{{ desc }}</p>
        }
    </div>
    <div class="section-header-actions">
        <ng-content></ng-content>
    </div>
</div>
